var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"page-header-phone",class:[_vm.data.class, _vm.data.staticClass]},[_c('a',{attrs:{"href":"tel:1-888-746-3455","aria-label":"Call us at 1.888.746.3455"}},[_vm._v("+1.888.746.3455")])])}
var staticRenderFns = []

export { render, staticRenderFns }